

















































import { Component, Vue } from 'vue-property-decorator';
import { queryFreight, modifyFreight } from '@/utils/api';

@Component
export default class freightInstall extends Vue {
  type: number = 3; //判断是哪个模式
  current: number = 3; //判断当前点击是哪个
  cancel: number = 3; //点击改变
  data: object = {}; //当前数据
  created() {
    this.queryFreight();
  }
  // 查询当前运费模板
  queryFreight() {
    queryFreight()
      .then((data: any) => {
        this.type = data.type;
        this.data = data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // 点击选择当前模板
  selected(id) {
    this.current = id;
    this.cancel = this.type;
    this.data['type'] = id;
  }

  // 确认
  onSubmit() {
    this.$confirm('确认修改运费模式配置吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.modifyFreight();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改',
        });
      });
  }
  // 修改模板
  modifyFreight() {
    modifyFreight(this.data).then((res) => {
      this.$message({
        type: 'success',
        message: '修改成功',
      });
      this.queryFreight();
      this.current = 3;
      this.cancel = 3;
    });
  }
}
